export default __webpack_public_path__ + "static/media/competence.7172074d.svg";